module.exports = __webpack_public_path__ + "static/img/101209.c2728a29.png";